module.exports = __webpack_public_path__ + "img/002-target.97468233.png";